module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 5);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  e.exports = r(3)();
}, function (e, t, r) {
  e.exports = function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 1);
  }([function (e, t) {
    e.exports = r(0);
  }, function (e, t, r) {
    "use strict";

    r.r(t), r.d(t, "useElapsedTime", function () {
      return i;
    });
    var n = r(0);

    function o(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
          var r = [],
              n = !0,
              o = !1,
              i = void 0;

          try {
            for (var a, u = e[Symbol.iterator](); !(n = (a = u.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
              ;
            }
          } catch (e) {
            o = !0, i = e;
          } finally {
            try {
              n || null == u.return || u.return();
            } finally {
              if (o) throw i;
            }
          }

          return r;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var i = function i(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.durationMilliseconds,
          i = t.onComplete,
          a = t.startAt,
          u = "number" == typeof r,
          c = Object(n.useState)(a || 0),
          l = o(c, 2),
          f = l[0],
          s = l[1],
          p = Object(n.useRef)(null),
          d = Object(n.useRef)(null),
          m = function e(t) {
        if (null === d.current) return d.current = t, void (p.current = requestAnimationFrame(e));
        s(function (n) {
          var a = n + (t - d.current);
          if (!u || a < r) return d.current = t, p.current = requestAnimationFrame(e), a;

          if ("function" == typeof i) {
            var c = o(i() || [], 2),
                l = c[0],
                f = void 0 !== l && l,
                m = c[1];
            f && setTimeout(function () {
              s(0), d.current = null, p.current = requestAnimationFrame(e);
            }, void 0 === m ? 0 : m);
          }

          return r;
        });
      };

      return Object(n.useLayoutEffect)(function () {
        return e && (p.current = requestAnimationFrame(m)), function () {
          cancelAnimationFrame(p.current), d.current = null, p.current = null;
        };
      }, [e]), f;
    };
  }]);
}, function (e, t, r) {
  "use strict";

  var n = r(4);

  function o() {}

  function i() {}

  i.resetWarningCache = o, e.exports = function () {
    function e(e, t, r, o, i, a) {
      if (a !== n) {
        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw u.name = "Invariant Violation", u;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var r = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: i,
      resetWarningCache: o
    };
    return r.PropTypes = r, r;
  };
}, function (e, t, r) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, r) {
  "use strict";

  r.r(t);

  var n = r(0),
      o = r.n(n),
      i = r(1),
      a = r.n(i),
      u = r(2),
      c = function c(e, t, r, n) {
    return t + r * (e / n);
  },
      l = function l(e) {
    return {
      position: "relative",
      width: e,
      height: e,
      margin: "0 auto",
      zIndex: "99"
    };
  },
      f = function f(e, t) {
    return {
      display: "flex",
      WebkitBoxPack: "center",
      MsFlexPack: "center",
      justifyContent: "center",
      WebkitBoxAlign: "center",
      MsFlexAlign: "center",
      alignItems: "center",
      position: "relative",
      width: t,
      height: t,
      color: e,
      zIndex: "99"
    };
  },
      s = {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%"
  },
      p = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: 0,
    clip: "rect(0 0 0 0)",
    padding: 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    zIndex: "99"
  };

  function d(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function m(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? d(r, !0).forEach(function (t) {
        b(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : d(r).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function b(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  var y = function y(e) {
    var t = e.r,
        r = e.g,
        n = e.b,
        o = e.opacity;
    return "rgba(".concat(t, ", ").concat(r, ", ").concat(n, ", ").concat(o, ")");
  },
      v = function v(e, t, r) {
    var n = function (e) {
      return e.map(function (e) {
        var t = e[0].replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (e, t, r, n) {
          return "#".concat(t).concat(t).concat(r).concat(r).concat(n).concat(n);
        }).substring(1).match(/.{2}/g).map(function (e) {
          return parseInt(e, 16);
        });
        return [{
          r: t[0],
          g: t[1],
          b: t[2],
          opacity: 1
        }, e[1]];
      });
    }(e);

    if (!r) return n;
    var o = 0;
    return n.map(function (e, t) {
      var r = n.length === t + 1,
          i = "0%";

      if (t > 0) {
        var a = n[t - 1][1],
            u = Math.round(a ? 100 * a : 100);
        (o += u) > 100 || r ? (o = 100, i = "100%") : i = "".concat(o, "%");
      }

      var c = {
        offset: i,
        stopColor: y(e[0]),
        key: t
      };
      return [m({}, e[0], {
        gradient: c
      }), e[1]];
    });
  };

  function g(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
      var r = [],
          n = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, u = e[Symbol.iterator](); !(n = (a = u.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          n || null == u.return || u.return();
        } finally {
          if (o) throw i;
        }
      }

      return r;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  r.d(t, "CountdownCircleTimer", function () {
    return O;
  });

  var h = function h(e, t) {
    return e ? "countdown-circle-timer-gradient-".concat(t || Math.random().toString(36).substring(2)) : "";
  },
      O = function O(e) {
    var t = e.size,
        r = e.strokeWidth,
        i = e.trailColor,
        a = e.durationSeconds,
        d = e.isPlaying,
        b = e.colors,
        O = e.strokeLinecap,
        j = e.renderTime,
        w = e.isLinearGradient,
        x = e.gradientUniqueKey,
        T = e.onComplete,
        P = e.ariaLabel,
        E = e.renderAriaTime,
        S = e.initialRemainingTime,
        k = e.startAt,
        A = Object(n.useRef)(null),
        _ = g(Object(n.useState)(0), 2),
        M = _[0],
        C = _[1],
        R = Object(n.useMemo)(function () {
      return function (e, t) {
        var r = e / 2,
            n = t / 2,
            o = r - n,
            i = 2 * o;
        return "m ".concat(r, ",").concat(n, "\n          a ").concat(o, ",").concat(o, " 0 1,0 0,").concat(i, "\n          a ").concat(o, ",").concat(o, " 0 1,0 0,-").concat(i);
      }(t, r);
    }, [t, r]),
        L = Object(n.useMemo)(function () {
      return 1e3 * a;
    }, [a]),
        q = Object(n.useMemo)(function () {
      return function (e, t, r) {
        return "number" == typeof e ? 1e3 * (r - e) : t ? 1e3 * t : 0;
      }(S, k, a);
    }, [S, k, a]),
        F = Object(n.useMemo)(function () {
      return function (e, t, r) {
        var n = v(e, 0, r),
            o = 0;
        return n.map(function (e, r) {
          var i = n.length === r + 1;
          if (o >= t || i) return o = t, m({}, e[0], {
            colorEndTime: o
          });
          var a = o,
              u = void 0 !== e[1] ? a + e[1] * t : t - o,
              c = u >= t ? t : u,
              l = n[r + 1][0],
              f = {
            goalR: l.r - e[0].r,
            goalG: l.g - e[0].g,
            goalB: l.b - e[0].b
          };
          return o = c, m({}, e[0], {}, f, {
            colorStartTime: a,
            colorEndTime: c,
            duration: c - a
          });
        });
      }(b, L, w);
    }, [b, L, w]),
        W = Object(n.useMemo)(function () {
      return h(w, x);
    }, [w, x]);

    Object(n.useEffect)(function () {
      var e = function (e) {
        return e.getTotalLength().toFixed(2);
      }(A.current);

      C(e);
    }, []);

    var I = Object(u.useElapsedTime)(d, {
      durationMilliseconds: L,
      onComplete: T,
      startAt: q
    }),
        D = c(I, 0, M, L).toFixed(2),
        G = function (e, t) {
      if (1 === e.length) return y(e[0]);
      var r = e.find(function (e) {
        var r = e.colorEndTime;
        return t <= r;
      });
      if (void 0 === r.duration) return y(r);
      var n = t - r.colorStartTime,
          o = 0 | c(n, r.r, r.goalR, r.duration),
          i = 0 | c(n, r.g, r.goalG, r.duration),
          a = 0 | c(n, r.b, r.goalB, r.duration);
      return y({
        r: o,
        g: i,
        b: a,
        opacity: r.opacity
      });
    }(F, I),
        B = Math.ceil((L - I) / 1e3);

    return o.a.createElement("div", {
      style: l(t),
      "aria-label": P
    }, o.a.createElement("svg", {
      width: t,
      height: t,
      style: s,
      xmlns: "http://www.w3.org/2000/svg"
    }, w && o.a.createElement("defs", null, o.a.createElement("linearGradient", {
      id: W,
      x1: "100%",
      y1: "0%",
      x2: "0%",
      y2: "0%"
    }, F.map(function (e) {
      return o.a.createElement("stop", e.gradient);
    }))), o.a.createElement("path", {
      fill: "none",
      strokeWidth: r,
      stroke: i,
      d: R
    }), o.a.createElement("path", {
      fill: "none",
      stroke: w ? "url(#".concat(W, ")") : G,
      d: R,
      ref: A,
      strokeLinecap: O,
      strokeWidth: 0 === M ? 0 : r,
      strokeDasharray: M,
      strokeDashoffset: D
    })), "function" == typeof j && o.a.createElement("div", {
      "aria-hidden": "true",
      style: f(G, t)
    }, j(B, I, d)), "function" == typeof E && o.a.createElement("div", {
      role: "timer",
      "aria-live": "assertive",
      style: p
    }, E(B, I, d)));
  };

  O.propTypes = {
    durationSeconds: a.a.number.isRequired,
    colors: a.a.arrayOf(a.a.arrayOf(function (e, t, r, n, o) {
      var i = e[0],
          a = e[1];
      return i.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/) ? void 0 === a || a >= 0 && a <= 1 ? void 0 : new Error("Invalid prop '".concat(o, "[1]' supplied to '").concat(r, "'. Expect a number of color transition duration with value between 0 and 1.")) : new Error("Invalid prop '".concat(o, "[0]' supplied to '").concat(r, "'.Expect a color with HEX color code."));
    }).isRequired).isRequired,
    size: a.a.number,
    strokeWidth: a.a.number,
    trailColor: a.a.string,
    isPlaying: a.a.bool,
    strokeLinecap: a.a.oneOf(["round", "square"]),
    renderTime: a.a.func,
    isLinearGradient: a.a.bool,
    gradientUniqueKey: a.a.string,
    onComplete: a.a.func,
    ariaLabel: a.a.string,
    renderAriaTime: a.a.func,
    initialRemainingTime: a.a.number,
    startAt: a.a.number
  }, O.defaultProps = {
    size: 180,
    strokeWidth: 12,
    trailColor: "#d9d9d9",
    isPlaying: !1,
    strokeLinecap: "round",
    isLinearGradient: !1,
    ariaLabel: "Countdown timer",
    startAt: 0,
    zIndex: "99"
  }, O.displayName = "CountdownCircleTimer";
}]);